module.exports = __webpack_public_path__ + "static/media/img-web-resa@3x.c449fba6.png";